@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&family=Roboto:wght@400;500;700&display=swap");
@import "tailwindcss";

/* Design tokens из Figma-макета Landing-Yclients.
   Расширяем по мере обнаружения новых значений в секциях. */
@theme {
  --animate-wiggle: wiggle 0.45s ease-in-out;
  --breakpoint-3xl: 1920px;

  --color-ink-950: #041527;       /* «Color 4» — тёмный текст / акцент */
  --color-ink-700: #394959;       /* «Color 3» — основной текст */
  --color-ink-500: #676b94;       /* «Color 2» — приглушённый */
  /* Единственный акцентный синий: eyebrow секций, инлайн-ссылки на RIS.Promo,
     курсор и тултип в Hero. Раньше эту роль делили #1563ff, #155fff, #3b7eff
     и #3c7dff — расхождение было заметно на соседних экранах, а два последних
     не набирали 4.5 на белом (3.74 и 3.77). Этот даёт 4.93.
     Отдельно от CTA-градиента ниже: тот живёт на кнопках, этот — на тексте. */
  --color-accent: #1563ff;
  --color-cta-from: #0d6fe0;      /* CTA-градиент: начало */
  --color-cta-to: #145aff;        /* CTA-градиент: конец */

  --font-sans: "Inter", system-ui, -apple-system, sans-serif;
  --font-body: "Roboto", system-ui, -apple-system, sans-serif;
  --font-display: "Manrope", system-ui, -apple-system, sans-serif;
}

html {
  font-family: var(--font-sans);
  color: var(--color-ink-700);
  scroll-behavior: smooth;
}

body {
  margin: 0;
}

/* Цель якоря не должна уезжать под sticky-хедер: он занимает 64px (top 16 + высота 48). */
section[id] {
  scroll-margin-top: 80px;
}

/* Пользователям с включённым «уменьшить движение» — мгновенный переход.

   Анимации именно схлопываем до мгновенных, а не выключаем через `animation: none`.
   Причина: в Hero и в тултипе курсора элемент лежит под инлайновым `opacity: 0`,
   и снимает его сама анимация (`forwards` фиксирует конечный кадр). Отключишь
   анимацию — текст останется невидимым навсегда. При длительности 0.01ms кадр
   `to` применяется сразу, и всё оказывается на своих местах без движения.

   `!important` обязателен: переходы в секциях заданы инлайновым style из JS,
   а важность в таблице стилей перебивает инлайн без важности. */
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-delay: 0s !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    transition-delay: 0s !important;
  }
}

/* Горизонтальные слайдеры: прячем полосу прокрутки, свайп остаётся. */
.no-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Слайдер кейсов во всю ширину окна: следующая карточка уходит за край экрана,
   а не подрезается контейнером. Левый отступ повторяет отступ колонки контента
   (px-4 / sm:px-6 / lg:px-[7%] при max-w-[1200px]), чтобы первый слайд был
   выровнен с заголовком. Слайд на 32px уже колонки — за счёт этого справа
   всегда виден край следующего. */
.bleed-track {
  --gutter: 16px;
  --pad: max(var(--gutter), calc((100vw - 1200px) / 2));
  padding-left: var(--pad);
  padding-right: var(--pad);
  scroll-padding-left: var(--pad);
}
.bleed-track > * {
  width: min(1200px, calc(100vw - 2 * var(--gutter) - 32px));
}
@media (min-width: 640px) {
  .bleed-track {
    --gutter: 24px;
  }
}
@media (min-width: 1024px) {
  .bleed-track {
    --gutter: 7vw;
  }
}

/* Scroll reveal — базовое состояние и переходы */
.reveal {
  opacity: 0;
  transform: translateY(32px);
  transition: opacity 0.7s cubic-bezier(0.45, 0, 0.15, 1),
              transform 0.7s cubic-bezier(0.45, 0, 0.15, 1);
}
.reveal.in-view {
  opacity: 1;
  transform: translateY(0);
}

/* Hero load animations */
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Selection-sweep — заливка подсветки слева направо */
@keyframes selectSweep {
  from {
    background-size: 0% 100%;
  }
  to {
    background-size: 100% 100%;
  }
}

@keyframes wiggle {
  0%, 100% { transform: rotate(0deg); }
  25%       { transform: rotate(-18deg); }
  75%       { transform: rotate(14deg); }
}

/* Плавное появление tooltip — только opacity, без скейла */
@keyframes tooltipFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Модалка «Напомнить позже»: подложка проявляется, карточка чуть подъезжает */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
